import React from 'react'
import { Column } from 'react-virtualized'
import { components } from 'react-select'
import moment from 'moment'

import Table from '../../../containers/Tables/components/Table'
import TableStyles from '../../../containers/Tables/components/Table/Table.css'
import TableHeader from '../../../containers/Tables/components/TableHeader'
import TableActions from '../../../containers/Tables/components/TableActions'
import TableActionStyles from '../../../containers/Tables/components/TableActions/TableActions.css'
import SendIcon from 'static/images/send.svg'
import DownloadIcon from 'static/images/download.svg'
import { getSelectedList, DATE_WIDTH } from '../../../containers/Tables/Utilities'
import { DatePopover, SliderPopover, DropdownSearchPopover, ListPopover, MultiSelectListPopover } from '../../../containers/Popovers'
import styles from './ReportTable.css'
import {
  getDateFormat,
  REPORTS_TABLE_COLUMN_HEADERS,
  TABLE_CHECKBOX_WIDTH,
  TABLE_BULK_ACTIONS,
  CONTENT_WIDTH,
} from '../../../constants'
import { getName, getPatientName, getPhysicianName, isEscKey } from '../../../containers/Utilities'
import Loading from '../../../components/Loading'
import { filterIsPhysicianPermission } from '../../../store/appReducer'

class ReportTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: {},
    }
  }

  static getDerivedStateFromProps(props, s) {
    const state = s

    if (state.selected !== props.selected) {
      state.selected = props.selected
    }

    return state
  }

  dateFormat = getDateFormat(this.props.me)

  handleOnSelectionClick = selected => {
    const {
      onSelectionClick,
    } = this.props

    this.setState({
      selected,
    })

    if (typeof onSelectionClick === 'function') {
      onSelectionClick(selected)
    }
  }

  render() {
    const {
      noDataText = 'There are no reports available.',
      enableLoader,
      showLoader,
      showRowSelection = false,
      data,
      onRowClick,
      selectedIndex,
      sortBy,
      sortDirection,

      filterEndDate,
      filterPatient,
      filterPhysician,
      filterPrescription,
      filterBillingCode,
      filterEsign,
      filterExport,
      handleOnFilterButtonClick,
      handleOnFilterChange,
      handleOnSortClick,
      handleOnOutsidePopoverClick,
      handleOnBulkAction,
      handleOnBulkActionClearSelection,
      bulkActionComplete,
      bulkActionIsFetching,
      bulkActionSuccessMessage,
      selectedPopover,

      selectedStartDate,
      selectedEndDate,
      dateRange,

      showPatientColumns,
      patients,
      selectedPatientId,

      prescriptions,
      selectedPrescriptionId,

      physicians,
      selectedPhysicianId,
      selectedPhysicians,

      billingCodes,
      selectedBillingCode,

      esignOptions,
      selectedEsignedId,

      exportOptions,
      selectedExportedId,
    } = this.props
    const {
      selected,
    } = this.state

    const isAnySelected = Object.keys(selected).some(key => selected[key] === true)

    const ROW_HEIGHT = 50
    const PATIENT_WIDTH = 190
    const PHYSICIAN_WIDTH = 190
    const BILLING_CODE_WIDTH = 140
    const ESIGNED_WIDTH = 125
    const EXPORTED_WIDTH = 125
    let prescriptionWidth = CONTENT_WIDTH - DATE_WIDTH - PHYSICIAN_WIDTH - BILLING_CODE_WIDTH - ESIGNED_WIDTH - EXPORTED_WIDTH

    if (showRowSelection) {
      prescriptionWidth -= TABLE_CHECKBOX_WIDTH
    }

    if (showPatientColumns) {
      prescriptionWidth -= PATIENT_WIDTH
    }

    // FIX: handle this better
    let prescriptionPopoverClassname
    if (showRowSelection && showPatientColumns) {
      prescriptionPopoverClassname = styles.prescriptionPopoverWithPatientWithSelection
    } else if (!showRowSelection && showPatientColumns) {
      prescriptionPopoverClassname = styles.prescriptionPopoverWithPatient
    } else if (showRowSelection && !showPatientColumns) {
      prescriptionPopoverClassname = styles.prescriptionPopoverWithSelection
    } else {
      prescriptionPopoverClassname = styles.prescriptionPopover
    }


    let selectedPatient
    let patientsOptions

    if (patients && patients.data) {
      patientsOptions = patients.data.sortedByLastName.map(id => patients.data.byId[id])
      selectedPatient = selectedPatientId && patients.data.byId[selectedPatientId]
    }

    let selectedPhysician
    let physicianOptions = []
    const noneOptionItem = {
      id: '0',
      label: '<None>',
    }

    if (physicians && physicians.data) {
      physicianOptions = [ noneOptionItem ]
        .concat(filterIsPhysicianPermission(physicians.data.sortedByLastName.map(id => physicians.data.byId[id]))
          .map(p => ({
            id: p.id,
            label: getName(p.firstName, p.lastName, ''),
          })))

      selectedPhysician = selectedPhysicianId && physicians.data.byId[selectedPhysicianId]
    }

    let selectedPrescription
    let prescriptionsOptions

    if (prescriptions && prescriptions.data) {
      prescriptionsOptions = prescriptions.data.sortedByName.map(id => prescriptions.data.byId[id])
      selectedPrescription = selectedPrescriptionId && prescriptions.data.byId[selectedPrescriptionId]
    }

    let billingCodesOptions

    if (billingCodes && billingCodes.data) {
      billingCodesOptions = billingCodes.data.sortedByName.map(id => billingCodes.data.byId[id])
    }

    const PATIENT_NAME_MRN_SPLIT_DELIMITER = '!~|~!~|~!'

    const Option = ({ children, ...props }) => {
      const parts = children.split(PATIENT_NAME_MRN_SPLIT_DELIMITER)
      const name = parts[0]
      const mrn = parts[1]

      return (
        <div className={styles.patientOption}>
          <components.Option {...props}>
            <p className={TableStyles.primaryText}>
              {name}
            </p>
            <p className={`${TableStyles.secondaryText} ${TableStyles.number}`}>
              {mrn}
            </p>
          </components.Option>
        </div>
      )
    }

    const SingleValue = ({ children, ...props }) => {
      const parts = children.split(PATIENT_NAME_MRN_SPLIT_DELIMITER)
      const name = parts[0]
      const mrn = parts[1]

      return (
        <div className={styles.patientOption}>
          <components.SingleValue {...props}>
            <p className={TableStyles.primaryText}>
              {name}
            </p>
            <p className={`${TableStyles.secondaryText} ${TableStyles.number}`}>
              {mrn}
            </p>
          </components.SingleValue>
        </div>
      )
    }

    const numberOfSelection = getSelectedList(selected).length

    return (
      <div
        className={styles.reportTable}
        data-page="reports-table"
        data-value={showLoader ? null : data.length}
      >
        <Table
          noDataText={noDataText}
          enableLoader={enableLoader}
          showLoader={showLoader}
          // headerHeight={35}
          showRowSelection={showRowSelection}
          disableRowSelection={bulkActionComplete || bulkActionIsFetching}
          selected={selected}
          rowHeight={ROW_HEIGHT}
          uniqueKey="id"
          hasTableActions={isAnySelected}
          onSelectionClick={this.handleOnSelectionClick}
          onRowClick={onRowClick}
          scrollToIndex={selectedIndex}
          data={data}
          sortBy={sortBy}
          sortDirection={sortDirection}
          // colorField="severityClass"
        >
          <Column
            className={TableStyles.column}
            label="Date"
            dataKey={REPORTS_TABLE_COLUMN_HEADERS.END_DATE}
            width={DATE_WIDTH}
            headerRenderer={headerProps => {
              const {
                label,
              } = headerProps

              return (
                <TableHeader
                  label={label}
                  columnHeader={REPORTS_TABLE_COLUMN_HEADERS.END_DATE}
                  handleOnSortClick={handleOnSortClick}
                  handleOnFilterButtonClick={handleOnFilterButtonClick}
                  filterActive={filterEndDate}
                  sortBy={sortBy}
                  sortDirection={sortDirection}
                  selectedPopover={selectedPopover}
                  Popover={(
                    <div className={showRowSelection ? styles.endDatePopoverWithSelection : styles.endDatePopover}>
                      <DatePopover
                        handleOnChange={dates => handleOnFilterChange(REPORTS_TABLE_COLUMN_HEADERS.END_DATE, dates)}
                        handleOnOutsidePopoverClick={handleOnOutsidePopoverClick}
                        min={dateRange[0]}
                        max={dateRange[1]}
                        startDate={selectedStartDate}
                        endDate={selectedEndDate}
                      />
                    </div>
                  )}
                />
              )
            }}
            cellRenderer={({ dataKey, rowData }) => {
              let date
              if (rowData.endAt) {
                date = moment.utc(rowData.endAt).format(this.dateFormat)
              }
              return (
                <div className={TableStyles.centeredColumnContent}>
                  <p className={`${TableStyles.primaryText} ${TableStyles.centeredText}`}>
                    {date}
                  </p>
                </div>
              )
            }}
          />
          {showPatientColumns &&
            <Column
              className={TableStyles.column}
              width={PATIENT_WIDTH}
              label="Patient"
              dataKey={REPORTS_TABLE_COLUMN_HEADERS.PATIENT} // not needed but field required by library
              headerRenderer={headerProps => {
                const {
                  label,
                } = headerProps

                return (
                  <TableHeader
                    label={label}
                    columnHeader={REPORTS_TABLE_COLUMN_HEADERS.PATIENT}
                    handleOnSortClick={handleOnSortClick}
                    handleOnFilterButtonClick={handleOnFilterButtonClick}
                    filterActive={filterPatient}
                    sortBy={sortBy}
                    sortDirection={sortDirection}
                    selectedPopover={selectedPopover}
                    Popover={(
                      <div className={styles.patientPopover}>
                        <DropdownSearchPopover
                          noResultsMessage="No patient found"
                          handleOnOutsidePopoverClick={handleOnOutsidePopoverClick}
                          placeholder="MRN / Patient Name..."
                          isLoading={patients && patients.isFetching}
                          options={patientsOptions}
                          value={selectedPatient}
                          onChange={patient => handleOnFilterChange(REPORTS_TABLE_COLUMN_HEADERS.PATIENT, patient)}
                          getOptionLabel={p => {
                            let optionLabel = getPatientName(p.firstName, p.lastName, '')
                            if (p.customParticipantID) {
                              optionLabel += `${PATIENT_NAME_MRN_SPLIT_DELIMITER}${p.customParticipantID}`
                            }
                            return optionLabel
                          }}
                          components={{
                            Option,
                            SingleValue,
                          }}
                          getOptionFilter={(option, input) => {
                            const patient = option.data
                            const fields = `${patient.lastName}, ${patient.firstName} ${patient.customParticipantID}`.toLowerCase()
                            const searchInputParts = input.toLowerCase().split(' ')
                            return searchInputParts.every(text => fields.includes(text))
                          }}
                          getOptionValue={d => d.id}
                        />
                      </div>
                    )}
                  />
                )
              }}
              cellRenderer={({ rowData }) => {
                const rec = rowData
                let patientName = ''
                let mrn = ''
                let patient

                if (rec.participantId && patients.data) {
                  patient = patients.data.byId[rec.participantId]
                  patientName = getPatientName(patient.firstName, patient.lastName, '')
                  mrn = patient.customParticipantID
                }

                const secondaryTextClassName = `${TableStyles.secondaryText} ${TableStyles.number}`
                return (
                  <div className={TableStyles.columnContent}>
                    <p className={TableStyles.primaryText}>
                      {patientName}
                    </p>
                    <p className={secondaryTextClassName}>
                      {mrn}
                    </p>
                  </div>
                )
              }}
            />
          }
          <Column
            className={TableStyles.column}
            label="Ordering Provider"
            dataKey={REPORTS_TABLE_COLUMN_HEADERS.PHYSICIAN}
            width={PHYSICIAN_WIDTH}
            headerRenderer={headerProps => {
              const {
                label,
              } = headerProps

              return (
                <TableHeader
                  label={label}
                  columnHeader={REPORTS_TABLE_COLUMN_HEADERS.PHYSICIAN}
                  handleOnSortClick={handleOnSortClick}
                  handleOnFilterButtonClick={handleOnFilterButtonClick}
                  filterActive={filterPhysician}
                  sortBy={sortBy}
                  sortDirection={sortDirection}
                  selectedPopover={selectedPopover}
                  Popover={(
                    <div className={styles.physicianPopover}>
                      <MultiSelectListPopover
                        list={physicianOptions}
                        selected={selectedPhysicians}
                        getOptionLabel={d => d.label}
                        getOptionValue={d => d.id}
                        enableSearch={true}
                        handleOnClick={id => handleOnFilterChange(REPORTS_TABLE_COLUMN_HEADERS.ORDERING_PHYSICIAN, id)}
                        handleOnOutsidePopoverClick={handleOnOutsidePopoverClick}
                        controlShouldRenderValue={true}
                        backspaceRemovesValue={true}
                        onKeyDown={e => {
                          if (isEscKey(e)) {
                            handleOnOutsidePopoverClick()
                          }
                        }}
                      />
                    </div>
                  )}
                />
              )
            }}
            cellRenderer={({ dataKey, rowData }) => {
              const report = rowData
              let physican = ''
              let physicianName

              if (report.physicianMemberId && physicians.data) {
                physican = physicians.data.byId[report.physicianMemberId]
                if (physican) {
                  physicianName = getPhysicianName(physican.firstName, physican.lastName, '')
                }
              }

              return (
                <div className={TableStyles.columnContent}>
                  <p className={TableStyles.primaryText}>
                    {physicianName}
                  </p>
                </div>
              )
            }}
          />
          <Column
            className={TableStyles.column}
            label="Connection Plan"
            dataKey={REPORTS_TABLE_COLUMN_HEADERS.PRESCRIPTION}
            width={prescriptionWidth}
            headerRenderer={headerProps => {
              const {
                label,
              } = headerProps

              return (
                <TableHeader
                  label={label}
                  columnHeader={REPORTS_TABLE_COLUMN_HEADERS.PRESCRIPTION}
                  handleOnSortClick={handleOnSortClick}
                  handleOnFilterButtonClick={handleOnFilterButtonClick}
                  filterActive={filterPrescription}
                  sortBy={sortBy}
                  sortDirection={sortDirection}
                  selectedPopover={selectedPopover}
                  Popover={(
                    <div className={prescriptionPopoverClassname}>
                      <DropdownSearchPopover
                        noResultsMessage="No connection plan found"
                        handleOnOutsidePopoverClick={handleOnOutsidePopoverClick}
                        placeholder="Connection Plan..."
                        isLoading={prescriptions && prescriptions.isFetching}
                        options={prescriptionsOptions}
                        value={selectedPrescription}
                        onChange={prescription => handleOnFilterChange(REPORTS_TABLE_COLUMN_HEADERS.PRESCRIPTION, prescription)}
                        getOptionLabel={p => p.name || ''}
                        getOptionValue={d => d.id}
                      />
                    </div>
                  )}
                />
              )
            }}
            cellRenderer={({ dataKey, rowData }) => {
              const report = rowData
              let prescriptionName

              if (report.connectionTemplateId && prescriptions.data) {
                prescriptionName = prescriptions.data.byId[report.connectionTemplateId].name
              }

              return (
                <div className={TableStyles.columnContent}>
                  <p className={TableStyles.primaryText}>
                    {prescriptionName}
                  </p>
                </div>
              )
            }}
          />
          <Column
            className={TableStyles.column}
            label="Billing Code"
            dataKey={REPORTS_TABLE_COLUMN_HEADERS.BILLING_CODE}
            width={BILLING_CODE_WIDTH}
            headerRenderer={headerProps => {
              const {
                label,
              } = headerProps

              return (
                <TableHeader
                  label={label}
                  columnHeader={REPORTS_TABLE_COLUMN_HEADERS.BILLING_CODE}
                  handleOnSortClick={handleOnSortClick}
                  handleOnFilterButtonClick={handleOnFilterButtonClick}
                  filterActive={filterBillingCode}
                  sortBy={sortBy}
                  sortDirection={sortDirection}
                  selectedPopover={selectedPopover}
                  Popover={(
                    <div className={styles.billingCodesPopover}>
                      <MultiSelectListPopover
                        list={billingCodesOptions}
                        selected={selectedBillingCode}
                        getOptionLabel={d => d.name}
                        getOptionValue={d => d.id}
                        enableSearch={false}
                        handleOnClick={billingCode => handleOnFilterChange(REPORTS_TABLE_COLUMN_HEADERS.BILLING_CODE, billingCode)}
                        handleOnOutsidePopoverClick={handleOnOutsidePopoverClick}
                      />
                    </div>
                  )}
                />
              )
            }}
            cellRenderer={({ dataKey, rowData }) => {
              const report = rowData
              let text = null
              if (report.billingCodeId && billingCodes.data) {
                text = billingCodes.data.byId[report.billingCodeId].name
              }

              return (
                <div className={TableStyles.columnContent}>
                  <p className={TableStyles.primaryText}>
                    {text}
                  </p>
                </div>
              )
            }}
          />
          <Column
            className={TableStyles.column}
            label="E-Signed"
            dataKey={REPORTS_TABLE_COLUMN_HEADERS.ESIGNED}
            width={ESIGNED_WIDTH}
            headerRenderer={headerProps => {
              const {
                label,
              } = headerProps

              return (
                <TableHeader
                  label={label}
                  columnHeader={REPORTS_TABLE_COLUMN_HEADERS.ESIGNED}
                  handleOnSortClick={handleOnSortClick}
                  handleOnFilterButtonClick={handleOnFilterButtonClick}
                  filterActive={filterEsign}
                  sortBy={sortBy}
                  sortDirection={sortDirection}
                  selectedPopover={selectedPopover}
                  Popover={(
                    <div className={styles.esignPopover}>
                      <ListPopover
                        list={esignOptions}
                        selected={selectedEsignedId}
                        getOptionLabel={d => d.label}
                        getOptionValue={d => d.id}
                        handleOnClick={id => handleOnFilterChange(REPORTS_TABLE_COLUMN_HEADERS.ESIGNED, id)}
                        handleOnOutsidePopoverClick={handleOnOutsidePopoverClick}
                      />
                    </div>
                  )}
                />
              )
            }}
            cellRenderer={({ dataKey, rowData }) => {
              const report = rowData
              const isEsigned = report.esignedAt !== null

              return (
                <div className={TableStyles.centeredColumnContent}>
                  <p className={styles[isEsigned ? 'esigned' : 'notEsigned']}>
                    {isEsigned ?
                      'Yes'
                      :
                      'No'
                    }
                  </p>
                </div>
              )
            }}
          />
          <Column
            className={TableStyles.column}
            label="exported"
            dataKey={REPORTS_TABLE_COLUMN_HEADERS.EXPORTED}
            width={EXPORTED_WIDTH}
            headerRenderer={headerProps => {
              const {
                label,
              } = headerProps

              return (
                <TableHeader
                  label={label}
                  columnHeader={REPORTS_TABLE_COLUMN_HEADERS.EXPORTED}
                  handleOnSortClick={handleOnSortClick}
                  handleOnFilterButtonClick={handleOnFilterButtonClick}
                  filterActive={filterExport}
                  sortBy={sortBy}
                  sortDirection={sortDirection}
                  selectedPopover={selectedPopover}
                  Popover={(
                    <div className={styles.exportPopover}>
                      <ListPopover
                        list={exportOptions}
                        selected={selectedExportedId}
                        getOptionLabel={d => d.label}
                        getOptionValue={d => d.id}
                        handleOnClick={id => handleOnFilterChange(REPORTS_TABLE_COLUMN_HEADERS.EXPORTED, id)}
                        handleOnOutsidePopoverClick={handleOnOutsidePopoverClick}
                      />
                    </div>
                  )}
                />
              )
            }}
            cellRenderer={({ dataKey, rowData }) => {
              const report = rowData
              const isExported = report.exportedAt !== null

              return (
                <div className={TableStyles.centeredColumnContent}>
                  <p className={styles[isExported ? 'exported' : 'notExported']}>
                    {isExported ?
                      'Yes'
                      :
                      'No'
                    }
                  </p>
                </div>
              )
            }}
          />
        </Table>
        <TableActions
          selected={selected}
          visible={isAnySelected}
          clearSelection={handleOnBulkActionClearSelection}
          bulkActionComplete={bulkActionComplete}
          bulkActionIsFetching={bulkActionIsFetching}
          successMessage={bulkActionSuccessMessage}
        >
          {bulkActionIsFetching
            ? (
              <button disabled className={TableActionStyles.submitLoading}>
                <Loading />
              </button>
            )
            : (
              <button
                className={`${TableActionStyles.actionButtonWithIcon} ${styles.exportToEmail}`}
                onClick={() => handleOnBulkAction(TABLE_BULK_ACTIONS.MARK_AS_EXPORT)}
                data-page="reports-table-bulk-action"
                data-action="export-patient-reports"
              >
                <SendIcon />
                <span>{numberOfSelection === 1 ? 'Export Patient Report' : 'Export Patient Reports'}</span>
              </button>
            )
          }
          {bulkActionIsFetching
            ? (
              <button disabled className={TableActionStyles.submitLoading}>
                <Loading />
              </button>
            )
            : (
              <button
                className={TableActionStyles.actionButtonWithIcon}
                onClick={() => handleOnBulkAction(TABLE_BULK_ACTIONS.DOWNLOAD_LIST)}
                data-page="reports-table-bulk-action"
                data-action="download-csv"
              >
                <DownloadIcon />
                <span>Download CSV</span>
              </button>
            )
          }
        </TableActions>
      </div>
    )
  }
}

export default ReportTable



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/ReportTable/ReportTable.jsx